export default __webpack_public_path__ + "static/media/post5.70b40672.jpg";